var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"component":_vm.$options.name}},[_c('v-btn',{staticClass:"primary",attrs:{"dark":!_vm.membership('club').request,"disabled":!!_vm.membership('club').request,"loading":_vm.loading},on:{"click":_vm.register}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" mdi-wallet-membership ")]),_vm._v(" Register now for FREE membership ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }